import * as api from '../api';
import { LOGIN, CREATE, FETCH_ALL, DELETE, UPDATE } from '../constants/actionTypes';

export const login = (loginDetails, navigate) => async (dispatch) => {
    try {
        const userType = loginDetails.userType
        const data = await api.logIn(loginDetails);
        dispatch({type: LOGIN, data});
        if(userType === "Student"){
            navigate('/studentHomepage')
        } else if(userType === "Lecturer") {
            navigate('/lecturerHomepage')
        } else {
            navigate('/adminHomepage')
        }
    } catch (error) {
        console.log(error)
    }
}

export const createUsers = (user) => async (dispatch) => {
    try {
        const response = await api.createUsers(user);
        dispatch({type: CREATE, payload: response});
    } catch (error) {
        console.log(error);
    }
}

export const getUsers = () => async (dispatch) => {
    try {
        const response = await api.getUsers();
        dispatch({type: FETCH_ALL, payload: response});
    } catch (error) {
        console.log(error.message);
    }
}

export const deleteUsers = (id) => async (dispatch) => {
    try {
        await api.deleteUsers(id);

        dispatch({type: DELETE, payload: id});
    } catch (error) {
        console.log(error);
    }
}

export const updateUsers = (id, users) => async (dispatch) => {
    try {
        const { data } = await api.updateUsers(id, users);
        dispatch({type: UPDATE, payload: data});
    } catch (error) {
        console.log(error);
    }
}